import { CommonModule } from '@angular/common';
import { Component, ContentChild, EventEmitter, Input, Optional, Output, Self, TemplateRef } from '@angular/core';
import { ControlValueAccessor, FormsModule, NgControl, ReactiveFormsModule } from '@angular/forms';
import { SelectModule } from 'primeng/select';
import { FormErrorMessageDirective } from '../../../directives/form-error-message.directive';

@Component({
  selector: 'app-dropdown',
  imports: [
    CommonModule,
    SelectModule,
    FormErrorMessageDirective,
    FormsModule,
    ReactiveFormsModule,
  ],
  templateUrl: './dropdown.html',
  styleUrl: './dropdown.scss',
})
export class Dropdown implements ControlValueAccessor {
  @Input() label = '';
  @Input() placeholder = '';
  @Input() options: any[] = [];
  @Input() optionLabel = 'label'; // property for display text
  @Input() optionValue = 'value'; // property for bound value
  @Input() disabled = false;
  @Input() filter = false;
  @Output() changed = new EventEmitter<any>();
  @Input() labelCustomClass: string = '';
  @Input() inputCustomClass: string = '';
  @Input() submitted: boolean = false;
  @Input() isVirtualScroll: boolean = false;
  @Input() group = false;
  @Input() optionGroupLabel: string = 'label';
  @Input() optionGroupChildren: string = 'items';
  value: any;
  @ContentChild('item') itemTemplate?: TemplateRef<any>;
  @ContentChild('selectedItem') selectedItemTemplate?: TemplateRef<any>;

  constructor(@Optional() @Self() public ngControl: NgControl) {
    if (this.ngControl != null) {
      this.ngControl.valueAccessor = this;
    }
  }

  private onChangeFn: (value: any) => void = () => { };
  private onTouchedFn: () => void = () => { };

  // Called when user selects an option
  onSelect(event: any) {
    this.value = event.value;
    this.onChangeFn(this.value);
    this.onTouchedFn();
    this.changed.emit(this.value);
  }

  // ControlValueAccessor methods
  writeValue(value: any): void {
    this.value = value ?? null;
  }
  registerOnChange(fn: any): void {
    this.onChangeFn = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouchedFn = fn;
  }
  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  getSelectedOption(value: any) {
    if (value === null || value === undefined) return null;
    if (!this.options?.length) return value;

    if (typeof value === 'object' && !Array.isArray(value)) return value;

    if (this.optionValue) {
      return this.options.find(opt => opt[this.optionValue] === value) || value;
    }
    return value;
  }
}
